export class CSubscription {
  endpoint: string | undefined
  p256dh: string | undefined
  auth: string | undefined
  isActive: boolean | undefined
  errorMessage: string | undefined
  
  public constructor(init?: Partial<CSubscription>) {
    Object.assign(this, init)
  }
}
